import { API } from '@/api';
import { mapToKey } from '@/utils/arrays';
import { filterBlanks } from '@/hooks/useStore/utils';
import { HEADER_HEIGHT } from '@/components/AppHeader';
import { SIDEBAR_WIDTH } from '@/components/AppSidebar';

export const classes = {
  wrapper: 'w-full h-full bg-sage-2',
  body: 'flex',
  content: 'flex-1 min-h-0 max-w-[1280px] overflow-auto p-8',
};

export const styles = {
  body: {
    height: `calc(100vh - ${HEADER_HEIGHT})`,
  },
  content: {
    marginLeft: SIDEBAR_WIDTH,
  },
};

export async function fetchCurrentUserCompanies() {
  // TODO: Pagination -- assuming 100 is large enough for now
  const [memberCompanies, investorCompanies] = await Promise.all([
    API.Users.fetchCurrentUserMemberCompanies({
      pagination: { page: 1, pageSize: 100 },
    }),
    API.Users.fetchCurrentUserInvestorCompanies({
      pagination: { page: 1, pageSize: 100 },
    }),
  ]);
  return {
    memberCompanies: memberCompanies.results,
    investorCompanies: mapToKey(investorCompanies.results, 'investorCompany'),
    financialReports: filterBlanks(
      mapToKey(investorCompanies.results, 'latestFinancialReport')
    ),
  };
}

export function getShortcut(e: KeyboardEvent) {
  switch (e.key?.toLowerCase()) {
    case 'u':
      return '\\U';
    case 'c':
      return '\\C';
    case 'i':
      return '\\I';
    case 'm':
      return '\\M';
    default:
      return null;
  }
}

export function getNavigation(e: KeyboardEvent) {
  switch (e.key?.toLowerCase()) {
    case 'h':
      return '/H';
    case 'c':
      return '/C';
    case 'i':
      return '/I';
    case 'a':
      return '/A';
    default:
      return null;
  }
}

export function isIgnoredKey(e: KeyboardEvent) {
  return ['Shift', '/', '\\'].includes(e.key);
}
